// Mock/local data for Beaudesert General Practice & Skin Care Clinic
export const clinicInfo = {
  name: "Beaudesert General Practice",
  fullName: "Beaudesert General Practice & Skin Care Clinic",
  phone: "(07) 5541 1011",
  phoneRaw: "0755411011",
  email: "reception@beaudesertgp.com.au",
  address: "35A William Street, Beaudesert QLD 4285",
  addressLine1: "35A William Street",
  addressLine2: "Beaudesert QLD 4285",
  hotdocUrl: "https://www.hotdoc.com.au/medical-centres/beaudesert-QLD-4285/beaudesert-general-practice-skin-cancer-clinic/doctors",
  mapEmbed: "https://www.google.com/maps?q=35A+William+Street+Beaudesert+QLD+4285&output=embed",
  mapDirections: "https://www.google.com/maps/dir/?api=1&destination=35A+William+Street+Beaudesert+QLD+4285",
  hours: {
    weekdays: "Mon – Fri: 8:00 AM – 5:00 PM",
    saturday: "Saturday: Closed",
    sunday: "Sunday: 8:00 AM – 12:00 PM"
  },
  facebook: "https://www.facebook.com/beaudesertgp/"
};

export const heroSlides = [
  {
    tagline: "Trusted General Practice · Beaudesert, QLD",
    title: "Compassionate care",
    titleAccent: "for every generation",
    subtitle: "The oldest and most established clinic in Beaudesert. With 70+ combined years of experience, our doctors deliver the highest quality of healthcare — from vaccinations to skin excisions. 100% bulk billed with a valid Medicare card.",
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_medical-site-new-1/artifacts/rcbnq9qw_PHOTO-2026-06-08-10-20-04.jpg"
  }
];

export const clinicPhotos = [
  {
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_medical-site-new-1/artifacts/rcbnq9qw_PHOTO-2026-06-08-10-20-04.jpg",
    label: "Clinic Exterior",
    caption: "35A William Street — Beaudesert General Practice & Skin Cancer Clinic"
  },
  {
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_medical-site-new-1/artifacts/wil3xwt0_PHOTO-2026-06-08-10-20-04%20%282%29.jpg",
    label: "Reception",
    caption: "Our friendly reception team is ready to help you check in"
  },
  {
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_medical-site-new-1/artifacts/wj8vxkd2_PHOTO-2026-06-08-10-20-06.jpg",
    label: "Waiting Room",
    caption: "Comfortable waiting area with on-site 4Cyte pathology access"
  },
  {
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_medical-site-new-1/artifacts/v7wqibmf_PHOTO-2026-07-21-12-39-06%20%285%29.jpg",
    label: "Waiting Room",
    caption: "Bright and welcoming space for you and your family"
  },
  {
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_medical-site-new-1/artifacts/410lu8wj_PHOTO-2026-07-21-12-39-06%20%286%29.jpg",
    label: "Waiting Room",
    caption: "Modern seating and a calm atmosphere while you wait"
  },
  {
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_medical-site-new-1/artifacts/60fuumyl_PHOTO-2026-07-21-12-39-06%20%281%29.jpg",
    label: "Treatment Room",
    caption: "Fully equipped for skin excisions, cryotherapy and minor procedures"
  },
  {
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_medical-site-new-1/artifacts/36te1ora_PHOTO-2026-07-21-12-39-05.jpg",
    label: "Treatment Room",
    caption: "Sterile treatment room with autoclave, procedure bed and clinical workstation"
  },
  {
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_medical-site-new-1/artifacts/6qbxv3x4_PHOTO-2026-07-21-12-39-06%20%284%29.jpg",
    label: "Treatment Room",
    caption: "Dual-bed treatment bay for skin procedures and minor surgery"
  },
  {
    src: "https://customer-assets-39nsmqrw.emergentagent.net/job_medical-site-new-1/artifacts/ivwojt5l_PHOTO-2026-06-08-10-20-04%20%281%29.jpg",
    label: "Procedure Room",
    caption: "Overhead surgical light and modern treatment bed for skin cancer surgery"
  }
];

export const aboutBadges = [
  { title: "100% Bulk Billing", desc: "No out-of-pocket cost with Medicare" },
  { title: "On-site 4Cyte Pathology", desc: "Blood tests without leaving the clinic" },
  { title: "Skin Cancer Care", desc: "Dermatoscopy, biopsies & excisions on-site" },
  { title: "ACRRM Accredited", desc: "Approved to train Rural Generalists" }
];

// Fallback services list (used before API returns / on service page rendering)
export const servicesFallback = [
  { slug: "skin-cancer-clinic", name: "Skin Cancer Clinic \u2014 Skin Examine", icon: "Microscope", short: "Full body skin examinations with computerised dermatoscopy and on-site treatment." },
  { slug: "general-consultations", name: "General Consultations & Family Medicine", icon: "Stethoscope", short: "Everyday care for you and your family \u2014 all ages, all stages of life." },
  { slug: "health-assessments", name: "Health Assessments & Chronic Disease Care Plans", icon: "HeartPulse", short: "Structured care plans for diabetes, heart disease, asthma and more." },
  { slug: "medicals", name: "Medicals \u2014 Insurance, Drivers Licence & Pre-Employment", icon: "ClipboardList", short: "Insurance, driver and pre-employment medicals \u2014 usually same-week." },
  { slug: "mental-health", name: "Counselling & Mental Health Consultations", icon: "Brain", short: "Compassionate support and access to Medicare-subsidised sessions." },
  { slug: "womens-health", name: "Women's Health, Pap Smears & Antenatal Care", icon: "Users", short: "Cervical screening, pregnancy tests, contraception and shared antenatal care." },
  { slug: "mens-health", name: "Men's Health", icon: "UserRound", short: "Prostate checks, cardiovascular health and mid-life reviews." },
  { slug: "diagnostics", name: "ECG, 24-Hour Holter & Spirometry", icon: "Activity", short: "On-site heart and lung function testing for fast diagnosis." },
  { slug: "immunisation-clinic", name: "Immunisation Clinic \u2014 Flu, Travel, Adult, Pneumococcal, Shingles & RSV", icon: "Syringe", short: "Flu, travel, adult immunisation, pneumococcal, shingles and RSV vaccines." },
  { slug: "minor-procedures", name: "Minor Surgery, Cryotherapy & Injury Care", icon: "Snowflake", short: "Sutures, mole removals, cryotherapy and simple fracture care on-site." },
  { slug: "workcover", name: "Work Cover & Return-to-Work Plans", icon: "ShieldCheck", short: "WorkCover Queensland assessments and suitable-duties planning." },
  { slug: "family-and-aged-care", name: "Children's Health, Family & Aged Care", icon: "Users", short: "From newborn checks to 75+ health assessments and aged-care support." }
];

export const fullServicesList = [
  "Skin Cancer Clinic \u2014 Skin Examine",
  "Health Assessments & Chronic Disease Care Plans",
  "Medicals: Insurance, Drivers Licence & Pre-Employment",
  "Counselling & Mental Health Consultations",
  "Pap smears",
  "Pregnancy tests",
  "Antenatal care",
  "ECG / 24-hour Holter monitoring",
  "Spirometry",
  "Travel & flu vaccination",
  "Adult immunisation, Pneumococcal, Shingles & RSV vaccines",
  "Immunisation clinic",
  "Treatment of injuries and simple fractures",
  "Minor surgery: sutures, mole and skin-cancer removal",
  "Cryotherapy / \u201cfreezing\u201d therapy for sunspots & warts",
  "Weight management & nutrition advice",
  "Work-cover injuries & return-to-work / suitable-duties plans",
  "Children\u2019s health",
  "Women\u2019s health",
  "Men\u2019s health",
  "Aged care",
  "Pre-travel health checks for international travel",
  "Malaria medication"
];

export const careTopics = [
  { title: "Family Care", desc: "From newborns to grandparents — trusted, continuous care for the whole family across generations." },
  { title: "When To See Us", desc: "Don't wait until symptoms worsen. Book early for skin checks, ongoing conditions, or new concerns." },
  { title: "How We Diagnose", desc: "Modern equipment including dermatoscopy and on-site 4Cyte pathology for fast, accurate diagnosis." },
  { title: "Who We Serve", desc: "Beaudesert families, farmers, workers and travellers — everyone deserves accessible, quality healthcare." },
  { title: "Preventive Health", desc: "Vaccinations, health assessments and screenings to keep you and your loved ones ahead of illness." },
  { title: "Procedures On-Site", desc: "Skin excisions, cryotherapy, wound care and minor surgery — all performed at our practice." }
];

export const howItWorks = [
  { step: "01", title: "Book Your Appointment", desc: "Book online via HotDoc or call (07) 5541 1011. New and existing patients welcome. 100% bulk billed with a valid Medicare card." },
  { step: "02", title: "Your Consultation", desc: "Meet with your doctor for a thorough, unhurried consultation. We listen carefully and explain every option in plain language." },
  { step: "03", title: "On-Site Diagnostics", desc: "4Cyte pathology is on-site Monday to Friday. Skin checks, dermoscopy and minor procedures are completed at our practice." },
  { step: "04", title: "Ongoing Care & Follow-Up", desc: "We build long-term relationships. Your doctor follows up on results, coordinates specialists and supports your care plan." }
];

export const doctors = [
  {
    id: "dr-basharat-hussain",
    slug: "dr-basharat-hussain",
    name: "Dr. Basharat Hussain",
    nickname: "Dr Basha",
    creds: "FRACGP · MBBS · AMC",
    role: "General Practitioner",
    bio: "Dr Hussain has worked in Beaudesert as a rural GP for many years. He has extensive experience in skin cancer detection and treatment, which he developed during his time at a skin clinic in Beaudesert. He also sees patients for all other medical issues. Dr Hussain — or \"Dr Basha\" as his regular patients call him — is known for his approachable and easy-going manner and his sense of humour.",
    interests: [
      "Skin cancer detection & treatment",
      "General practice"
    ],
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_medical-site-new-1/artifacts/abbf7t9l_Dr.%20Bash.jpg"
  },
  {
    id: "dr-aamir-siddiqui",
    slug: "dr-aamir-siddiqui",
    name: "Dr. Aamir A. Siddiqui",
    creds: "MBBS · AMC · Diploma in Skin Cancer",
    role: "General Practitioner",
    bio: "Dr Aamir Siddiqui is a dedicated General Practitioner with a strong background in orthopaedics and skin cancer surgery and medicine. He graduated from Nishtar Medical College, Multan (Pakistan) and has extensive clinical experience across multiple disciplines. Dr Siddiqui completed his early training and fellowship in orthopaedics, gaining valuable experience in musculoskeletal conditions and procedural care. Since 2013, he has been practising in general practice, providing comprehensive, patient-centred care to the community. He holds a Diploma in Skin Cancer Medicine and has a special interest in the diagnosis, management and treatment of skin cancers, including procedural skin work. Alongside this, he continues to manage a broad range of general medical conditions, offering holistic care to patients of all ages. Dr Siddiqui is currently undertaking the ACRRM training program, working towards Fellowship, and is committed to ongoing professional development and high-quality rural and regional healthcare.",
    interests: [
      "Skin cancer diagnosis, management & procedural work",
      "Orthopaedics & musculoskeletal care",
      "General practice for all ages"
    ],
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_medical-site-new-1/artifacts/3xlmoij6_IMG_6974.jpg"
  },
  {
    id: "dr-farhat-fatima",
    slug: "dr-farhat-fatima",
    name: "Dr. Farhat Fatima",
    creds: "MBBS · General Practitioner",
    role: "General Practitioner",
    bio: "Dr Farhat Fatima completed her medical degree in Pakistan before gaining clinical experience in the United Kingdom and later moving to Australia. She has worked within Queensland Health at Redlands and Ipswich Hospitals, gaining broad experience across General Medicine, Geriatrics, Paediatric Emergency, the High Dependency Unit (HDU), and the Medical Assessment and Planning Unit (MAPU). For the past two years, Dr Farhat has been practising as a General Practitioner and is proud to care for the Beaudesert community. She believes in treating every patient with kindness, respect and compassion, and enjoys building long-term relationships with individuals and families. Her goal is to provide high-quality, patient-centred care in a welcoming and supportive environment. She also performs Implanon insertion and removal, and is committed to ongoing professional development and helping patients of all ages achieve their best possible health.",
    interests: [
      "Paediatrics",
      "Women's health (incl. Implanon insertion & removal)",
      "Geriatrics & palliative care",
      "Minor procedures"
    ],
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_medical-site-new-1/artifacts/iqiw1iui_Farhat.webp"
  },
  {
    id: "dr-ala-abufarsakh",
    slug: "dr-ala-abufarsakh",
    name: "Dr. Ala Abufarsakh",
    tagline: "Bridging the gap between mind and body",
    creds: "General Practitioner · Advanced Psychiatry Training",
    role: "General Practitioner",
    bio: "Dr Ala Abufarsakh combines over a decade of hospital medical experience with advanced psychiatry training to provide warm, holistic, and patient-centred care. With broad experience across paediatrics, geriatrics, general medicine, ophthalmology and mental health, she understands the importance of caring for both the physical and emotional wellbeing of her patients. Dr Ala is passionate about creating a calm, respectful and welcoming environment where patients feel heard, supported and empowered in their health journey. She has a strong commitment to thoughtful, evidence-based care and her approach is guided by compassion, clinical insight, and a genuine desire to support patients at every stage of their life.",
    interests: [
      "Mental health & wellbeing",
      "Women's health & menopause",
      "Chronic disease management",
      "Skin cancer medicine",
      "Work-related health issues"
    ],
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_medical-site-new-1/artifacts/2wnfyiws_Alaa.jpg",
    imagePosition: "center 30%"
  },
  {
    id: "dr-hasan-pirzada",
    slug: "dr-hasan-pirzada",
    name: "Dr. Hasan Pirzada",
    creds: "MBBS · FRACGP · BSc (Anatomy)",
    role: "General Practitioner",
    bio: "Dr Hasan Pirzada is a skilled and experienced medical professional with a diverse background in clinical practice across multiple specialties. Originally hailing from Canada, he completed his medical training at The University of Queensland. Dr Pirzada has honed his expertise through extensive work in hospitals throughout Queensland and NSW, such as Ipswich General, Greenslopes and Lismore Base. His clinical experience spans internal medicine, cardiology, medical oncology, nephrology and palliative care, among others. Dr Pirzada has also undertaken various international medical electives, contributing to his global perspective on healthcare, before completing his RACGP Fellowship in Queensland. He provides comprehensive care including chronic disease management, urgent care and mental health support, and is committed to patient-centred care.",
    interests: [
      "Chronic disease management",
      "Mental health",
      "General medicine"
    ],
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_medical-site-new-1/artifacts/fzhxd10t_Dr%20Hassan.jpeg",
    imagePosition: "center 25%",
    languages: ["English"]
  },
  {
    id: "dr-sivajini-rudra",
    slug: "dr-sivajini-rudra",
    name: "Dr. Sivajini Rudra",
    creds: "MBBS · GP Registrar",
    role: "General Practitioner",
    bio: "Dr Sivajini Rudra is a kind, caring and dedicated GP Registrar who is committed to providing thoughtful, patient-centred care for individuals and families at all stages of life. She takes the time to listen carefully to patients' concerns and works collaboratively with them to support both immediate health needs and long-term wellbeing. Dr Rudra regularly consults with patients presenting with a wide range of conditions, and has special interests and expertise in children's, women's and mental health. She has extensive experience managing culturally diverse populations, including First Nations communities. She values continuity of care and aims to build trusted, long-term relationships, enabling personalised, well-coordinated care over time.",
    interests: [
      "Children's health & paediatrics",
      "Women's health",
      "Mental health",
      "Diabetes & chronic disease management",
      "General & family medicine",
      "WorkCover"
    ],
    image: "https://customer-assets-39nsmqrw.emergentagent.net/job_medical-site-new-1/artifacts/5enjy4oc_ChatGPT%20Image%20Sep%2030%2C%202026%2C%2008_11_57%20AM.png",
    imagePosition: "center 20%",
    languages: ["English", "Sinhalese", "Tamil"]
  }
];

export const logoUrl = "https://customer-assets-39nsmqrw.emergentagent.net/job_medical-site-new-1/artifacts/9u35co4p_RACGP_Acronym.png";
export const accreditationLogo = "https://customer-assets-39nsmqrw.emergentagent.net/job_medical-site-new-1/artifacts/yjw3rng9_QPA.png";

export const partners = [
  { name: "Bond University", logo: "/logos/bond.png", wordmark: true },
  { name: "Griffith University", logo: "/logos/griffith.png" },
  { name: "University of Queensland", logo: "/logos/uq.png" }
];

export const accreditationCertificate = {
  standard: "RACGP Standards for General Practices (5th edition)",
  awardedBy: "Quality Practice Accreditation Pty Ltd",
  certificateNumber: "GP59034-ACSQHC61-E62",
  awarded: "17 April 2025",
  commencement: "17 June 2025",
  expiry: "16 June 2028",
  pdfUrl: "https://customer-assets-39nsmqrw.emergentagent.net/job_medical-site-new-1/artifacts/k56a6oxb_6193_certificate_A4.pdf",
  scheme: "National General Practice Accreditation Scheme (NGPA)",
  regulator: "Australian Commission on Safety and Quality in Health Care",
  isqua: "ISQua EEA Accredited Organisation 2024–2028"
};

export const nurses = [
  {
    id: "kathryn-fuller",
    slug: "kathryn-fuller",
    name: "Mrs. Kathryn Fuller",
    creds: "Registered Nurse · Certificate in Orthopaedics",
    role: "Practice Nurse",
    bio: "With more than 40 years of nursing experience, Kathryn brings a wealth of knowledge and expertise to her role at Beaudesert General Practice and Skin Cancer Clinic. As a hospital-trained nurse with a Certificate in Orthopaedics, she has developed a broad clinical skill set across a variety of healthcare settings. Her career has included over 20 years in community nursing, where she supported patients to achieve the best possible health outcomes in their own homes and communities. Kathryn has also spent the past 8.5 years working in general practice, providing comprehensive, patient-centred care to people of all ages. She is passionate about delivering compassionate, high-quality healthcare and believes in building trusting relationships with her patients — creating a welcoming and supportive environment where patients feel comfortable, respected, and confident in their care.",
    interests: [
      "40+ years of nursing experience",
      "20+ years in community nursing",
      "8.5 years in general practice",
      "Orthopaedic & multi-disciplinary care"
    ]
  },
  {
    id: "sarah-healey",
    slug: "sarah-healey",
    name: "Mrs. Sarah Healey",
    creds: "Enrolled Nurse",
    role: "Practice Nurse",
    bio: "With over nine years of experience as an Enrolled Nurse, Sarah is passionate about providing compassionate, patient-centred care across all stages of life. Prior to relocating to Beaudesert in 2023, she specialised in sexual health and transgender medicine, where she developed a strong commitment to delivering inclusive, respectful, and evidence-based healthcare. Since joining Beaudesert General Practice and Skin Cancer Clinic in May 2023, Sarah has enjoyed building lasting relationships with patients and supporting the local community through high-quality primary healthcare. She is dedicated to creating a welcoming environment where patients feel comfortable, heard, and supported in achieving their best health outcomes.",
    interests: [
      "9+ years as an Enrolled Nurse",
      "Sexual health & transgender medicine background",
      "Inclusive, respectful, evidence-based care",
      "Serving Beaudesert since May 2023"
    ]
  }
];

export const navLinks = [
  { label: "Home", href: "/#home" },
  { label: "About", href: "/#about" },
  { label: "Services", href: "/#services" },
  { label: "Our Doctors", href: "/#doctors" },
  { label: "News", href: "/news" },
  { label: "Fees", href: "/fees" },
  { label: "Contact", href: "/#contact" }
];

export const publicHolidays = [
  // Queensland Public Holidays 2026 (add/adjust as needed)
  { date: "2026-01-01", name: "New Year's Day" },
  { date: "2026-01-26", name: "Australia Day" },
  { date: "2026-04-03", name: "Good Friday" },
  { date: "2026-04-04", name: "Easter Saturday" },
  { date: "2026-04-05", name: "Easter Sunday" },
  { date: "2026-04-06", name: "Easter Monday" },
  { date: "2026-04-25", name: "Anzac Day" },
  { date: "2026-05-04", name: "Labour Day (QLD)" },
  { date: "2026-08-12", name: "Royal Queensland Show (Ekka)" },
  { date: "2026-10-05", name: "King's Birthday (QLD)" },
  { date: "2026-12-24", name: "Christmas Eve (afternoon)" },
  { date: "2026-12-25", name: "Christmas Day" },
  { date: "2026-12-26", name: "Boxing Day" }
];

export const afterHours = {
  headline: "Need care when we're closed?",
  desc: "Outside our opening hours, please attend Beaudesert Hospital for urgent medical care. For life-threatening emergencies, always call 000.",
  hospital: {
    name: "Beaudesert Hospital",
    address: "64 Tina Street, Beaudesert QLD 4285",
    phone: "(07) 5541 9111",
    phoneRaw: "0755419111",
    mapsUrl: "https://www.google.com/maps/dir/?api=1&destination=Beaudesert+Hospital+Tina+Street+Beaudesert+QLD"
  },
  emergency: {
    label: "Life-threatening emergency",
    number: "000"
  }
};
